export default __webpack_public_path__ + "static/Itubaina-261152b7f0b4169ebdfba62395604bf3.jpg";